exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".agentTaskForm{padding-top:10px;margin-top:25px;margin-bottom:30px;border-top:1px solid #ccc;border-bottom:1px solid #ccc}.agentTaskForm .taskActive{font-size:1.8em}.agentTaskForm input.form-control{margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/crm/agent_task_form.scss
// module id = 810
// module chunks = 0